<div class="search-bar-field-label">
  <core-label-action
    [label]="filter.item" 
    (actionClick)="onRemove(filter)"
  ></core-label-action>
</div>